export default "__VITE_ASSET__BwTudwJR__"